import { render } from "./Assign.vue?vue&type=template&id=c10ea0fa&scoped=true"
import script from "./Assign.vue?vue&type=script&lang=js"
export * from "./Assign.vue?vue&type=script&lang=js"

import "./Assign.vue?vue&type=style&index=0&id=c10ea0fa&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10ea0fa"]])

export default __exports__